import { baseInstance } from "axios/instances";
import { IdleTimerConfigPayload } from "types/configuration";

export const getIdleTimerConfig = async () => {
    const res = await baseInstance.get(`/configurations/getconfiguration`);
    return res.data;
};

export const setIdleTimerConfig = async (payload: IdleTimerConfigPayload) => {
    const res = await baseInstance.post(`/configurations/setconfiguration`, payload);
    return res.data;
};